import { Injectable } from '@angular/core';
import { PlanType, RegistrationData, Plan } from '@pedix-workspace/utils';
import { COUNTRY_LIST, ICountry } from '@pedix-workspace/angular-ui-form';

@Injectable({
  providedIn: 'root',
})
export class RegistrationSharedService {

  availablesPlan = [PlanType.BASIC, PlanType.INTERMEDIATE, PlanType.ADVANCED];
  availablesBillingTypes = ['MONTLY', 'YEARLY'];
  selectedPlan: Plan;
  promotionCode: string;
  businessCategory: string;
  customCategoryText = '';

  registrationData: RegistrationData = {
    seller: '',
    customer: {
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      discoverySource: ''
    },
    account: {
      username: '',
      password: '',
    },
    establishment: {
      name: '',
      slug: '',
      phone: '',
      // @ts-ignore
      countryCode: '',
      countryDetail: '',
      categories: [],
    },
    acceptTermsAndConditions: true,
  };

  getCountrySelected(): ICountry | undefined {
    return COUNTRY_LIST.find(
      country => country.code === this.registrationData.establishment.countryCode,
    );
  }
}
